import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { NULL_FUNCTION } from 'config/constants'
import { useEffect, useRef, useState } from 'react'
import { useAirdropBoxStorage } from 'state/bonus/hooks'
import styled from 'styled-components'

const AirdropBoxStorage: React.FC<{ onClick: () => void | Promise<void>; alwaysEnabled?: boolean } & BoxProps> = ({
  onClick,
  alwaysEnabled,
  ...props
}) => {
  const isMounted = useRef(false)
  const [initAnimation, setInitAnimation] = useState(false)
  const { airdropBoxStorage } = useAirdropBoxStorage()
  const cachedAirdropBoxStorageLength = useRef(airdropBoxStorage.length)

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true
      return
    }

    if (airdropBoxStorage.length > cachedAirdropBoxStorageLength.current) {
      setInitAnimation(true)
      setTimeout(() => setInitAnimation(false), 1000)
    }

    cachedAirdropBoxStorageLength.current = airdropBoxStorage.length
  }, [airdropBoxStorage.length])

  return (
    <StyledAirdropGiftBox
      id="airdrop-gift-box"
      $disabled={!alwaysEnabled && airdropBoxStorage.length === 0}
      className={initAnimation ? 'animate' : ''}
      {...props}
    >
      <Box position="relative" className="box-storage">
        {airdropBoxStorage.length > 0 && (
          <StyledAirdropLength position="absolute" top={'-3px'} right={['-8px', '', '-11px']}>
            <Flex height={12} minWidth="12px" width="fit-content" justifyContent="center" alignItems="center">
              <Text textAlign="center" fontSize="10px" fontWeight={700}>
                {airdropBoxStorage.length}
              </Text>
            </Flex>
          </StyledAirdropLength>
        )}
        <Box
          className="airdrop-box-storage"
          width={[28, 28, 32]}
          height={[28, 28, 32]}
          onClick={!alwaysEnabled && airdropBoxStorage.length === 0 ? NULL_FUNCTION : onClick}
        >
          <Image src="/images/airdrop/airdrop-gift-box.png" width={32} height={32} />
        </Box>
      </Box>
    </StyledAirdropGiftBox>
  )
}

const StyledAirdropGiftBox = styled(Box)<{ $disabled?: boolean }>`
  filter: ${({ $disabled }) => ($disabled ? ' grayscale(1)' : 'unset')};

  &.animate {
    animation: zoomout 0.5s;
  }

  &.disabled {
    animation: zoomout 0.5s;
  }

  @keyframes zoomout {
    0% {
      transform: scale(1);
    }
    10% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
`

const StyledAirdropLength = styled(Box)`
  padding: 2px 4px;
  background: #1877f2;
  z-index: 1;
  border-radius: 40px;
`

export default AirdropBoxStorage
